import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
// const BASE_URL = "http://localhost:8080";
const BASE_URL = "https://api.globelinkplacement.com";

export const generateMandateTokenThunk = createAsyncThunk(
  "mandate/generateMandateTokenThunk",
  async (mandateData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/mandate/generate-mandate-token`,
        mandateData
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to register the mandate";
      return rejectWithValue(errorMessage);
    }
  }
);

export const generateAadhaarOTPThunk = createAsyncThunk(
  "mandate/generateAadhaarOTPThunk",
  async (aadhaar_number, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/auth/generate-aadhaar-otp`,
        { aadhaar_number: aadhaar_number }
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to generate the otp";
      return rejectWithValue(errorMessage);
    }
  }
);

export const verifyAadhaarOTPThunk = createAsyncThunk(
  "mandate/verifyAadhaarOTPThunk",
  async (verifyData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/auth/verfiy-aadhaar-otp`,
        { client_id: verifyData.client_id, otp: verifyData.otp }
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to generate the otp";
      return rejectWithValue(errorMessage);
    }
  }
);

export const generateMobileOtpThunk = createAsyncThunk(
  "mandate/generateMobileOtpThunk",
  async (phone, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/auth/generate-mobile-otp`,
        { phone: phone }
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to generate the otp";
      return rejectWithValue(errorMessage);
    }
  }
);

export const verifyMobileOtpThunk = createAsyncThunk(
  "mandate/verifyMobileOtpThunk",
  async (verificationData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/auth/verify-mobile-otp`,
        verificationData
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to verify the otp";
      return rejectWithValue(errorMessage);
    }
  }
);

// Async action to generate agreement
export const generateAgreementThunk = createAsyncThunk(
  "agreement/generateAgreementThunk",
  async (agreementData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/fieldExecutive/generate-agreement-on-website`,
        agreementData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const registerExecutiveThunk = createAsyncThunk(
  "mandate/registerExecutiveThunk",
  async (registeredData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/fieldExecutive/register-executive-on-website`,
        registeredData
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to registered the executive";
      return rejectWithValue(errorMessage);
    }
  }
);

export const fetchFieldExecByIdThunk = createAsyncThunk(
  "mandate/fetchFieldExecByIdThunk",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/fieldExecutive/getFieldExecById/${id}`
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to registered the executive";
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateFieldExecByIdThunk = createAsyncThunk(
  "mandate/updateFieldExecByIdThunk",
  async (mandateData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/mandate/updateMandate`,
        mandateData
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to registered the executive";
      return rejectWithValue(errorMessage);
    }
  }
);

export const getMandateAmountThunk = createAsyncThunk(
  "mandate/getMandateAmountThunk",
  async ({ rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/fieldexecutive/getMaxAmount`
      );
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch all the transaction";
      return rejectWithValue(errorMessage);
    }
  }
);

const mandateSlice = createSlice({
  name: "mandate",
  initialState: {
    url: "",
    loading: false,
    status: "idle",
    error: null,
    aadhaarData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registerExecutiveThunk.pending, (state, action) => {
        state.loading = true;
        state.status = "pending";
        state.error = null;
      })
      .addCase(registerExecutiveThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "success";
      })
      .addCase(registerExecutiveThunk.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(generateMandateTokenThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateMandateTokenThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(generateMandateTokenThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generateAadhaarOTPThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "pending";
      })
      .addCase(generateAadhaarOTPThunk.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.status = "success";
      })
      .addCase(generateAadhaarOTPThunk.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(verifyAadhaarOTPThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "pending";
      })
      .addCase(verifyAadhaarOTPThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.aadhaarData = action.payload.data.data;
        state.status = "success";
      })
      .addCase(verifyAadhaarOTPThunk.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(generateMobileOtpThunk.pending, (state) => {
        state.loading = true;
        state.status = "pending";
        state.error = null;
      })
      .addCase(generateMobileOtpThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "success";
        state.error = null;
      })
      .addCase(generateMobileOtpThunk.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(verifyMobileOtpThunk.pending, (state) => {
        state.loading = true;
        state.status = "pending";
        state.error = null;
      })
      .addCase(verifyMobileOtpThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "success";
        state.error = null;
      })
      .addCase(verifyMobileOtpThunk.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(generateAgreementThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateAgreementThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.url = action.payload.url;
      })
      .addCase(generateAgreementThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchFieldExecByIdThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFieldExecByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchFieldExecByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateFieldExecByIdThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFieldExecByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateFieldExecByIdThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMandateAmountThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMandateAmountThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getMandateAmountThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default mandateSlice.reducer;
